var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex" },
    _vm._l(_vm.layoutOptions, function(layout, index) {
      return _c(
        "button",
        {
          key: "layout_btn" + index,
          staticClass:
            "btn-view-custom btn-light-new-grid black text-size-large p-2 border-0",
          class: layout.isActive ? "grid-buton-active" : "",
          attrs: { id: "LayoutBtnsTooltip", variant: "light", size: "sm" },
          on: {
            click: function($event) {
              return _vm.handleLayoutChangeClick(layout.text, $event)
            }
          }
        },
        [
          _c("img", {
            staticClass: "layout-change-icon",
            attrs: { src: layout.icon, alt: "" }
          })
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }